import http from "@/http/aisea/axios";
const resource = "/enterprise/users/";

export default {
  fetch(userId) {
    return http.get(`${resource}${userId}/licenses`);
  },

  add(userId, payload) {
    return http.post(`${resource}${userId}/licenses`, payload);
  },

  update(userId, licenseId, payload) {
    return http.put(`${resource}${userId}/licenses/${licenseId}`, payload);
  },

  delete(userId, licenseId) {
    return http.delete(`${resource}${userId}/licenses/${licenseId}`);
  }
};
